import { formatMemberCSV } from "./formatMemberCSV";
import { getSelectedMembers } from "./getSelectedMembers";
export function buildDownloadCSV() {
    let data = null;
    const waitForAllCSVs = [];
    const from = document.querySelector("#from").value;
    const to = document.querySelector("#to").value;
    const btn = document.querySelector("#download");
    btn.innerHTML = `<i class="fa-solid fa-spinner fa-spin-pulse"></i>`;
    btn.setAttribute("disabled", "true");
    getMemberIDs().forEach((id) => {
        waitForAllCSVs.push(fetch(`https://www.cedarparkchurchofchrist.org/admin/attendance/details/csv?member_id=${id}&from=${from}&to=${to}`)
            .then((resp) => resp.text())
            .then((memberStr) => {
            if (memberStr.indexOf("<html") === -1) {
                data = formatMemberCSV(memberStr, data);
            }
        }));
    });
    Promise.all(waitForAllCSVs).then(() => {
        const blob = new Blob([data], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);
        window.location.href = url;
        btn.innerHTML = `
            Download CSV
            <i class="fa-solid fa-download"></i>
        `;
        btn.removeAttribute("disabled");
    });
}
function getMemberIDs() {
    return getSelectedMembers(document.querySelectorAll("#members option")).map((opt) => opt.getAttribute("value"));
}
